import React from 'react';
export const GroupContext = React.createContext({});
